<div class="product-view-container">
	<nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
		<span class="navbar-brand">Add Courier</span>
		<div class="navbar-nav mr-auto"></div>
		<button type="button" class="btn btn-secondary btn-cancel mr-3" [routerLink]="['/regional/courier']">
			<span>Cancel</span>
		</button>
		<button type="button" class="btn btn-primary btn-save" (click)="save()">
			<span>Save</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
	</nav>
	<div class="product-container">
		<mat-card>
			<div class="row">
				<div class="col-8">
					<label>Courier Name</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="courier.name" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>Courier Code</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="courier.code" type="text" class="form-control" (input)="dataChanged()"
							placeholder="Ex: LBC">
					</div>
					<label>Courier Type</label>
					<select [(ngModel)]="courier.courierType" name="courierType" class="custom-select" required>
						<option value="">Select a courier type</option>
						<option *ngFor="let courierType of courierTypes" value="{{courierType.id}}">{{ courierType.name}}</option>
					</select>
					<label>Country</label>
					<select [(ngModel)]="courier.countryId" name="countryId" class="custom-select" required>
						<option value="0">Select a country</option>
						<option *ngFor="let country of countries" value="{{country.id}}">{{ country.name }}</option>
					</select>
					<label>Description</label>
					<div class="input-group mb-3">
						<textarea [(ngModel)]="courier.description" class="form-control" rows="5"
							(input)="dataChanged()"></textarea>
					</div>
				</div>
			</div>
		</mat-card>
	</div>
</div>